import { z } from 'zod';

export const programDetailSearchSchema = z.object({
  q: z.string().optional().catch(undefined),
  jobType: z.string().optional().catch(undefined),
  workModel: z.string().optional().catch(undefined),
  workload: z.string().optional().catch(undefined),
  state: z.string().optional().catch(undefined),
  city: z.string().optional().catch(undefined),
});

export type ProgramDetailSearch = z.infer<typeof programDetailSearchSchema>;
